module.exports = __webpack_public_path__ + "media/signup-react/View-f14fbc44.svg";